module.exports = __webpack_public_path__ + "img/results-icon.1b345991.svg";